// extracted by mini-css-extract-plugin
module.exports = {"mobileFilter":"styles_mobileFilter__Ehg9N","content":"styles_content__1LTGd","footer":"styles_footer__VFOYz"};